const capitalize = (text: string) => {
    return text[0].toUpperCase() + text.substring(1, text.length).toLowerCase();
};

export default capitalize;
